import { render, staticRenderFns } from "./ObjectTopbar.vue?vue&type=template&id=4a1d35f6&"
import script from "./ObjectTopbar.vue?vue&type=script&lang=js&"
export * from "./ObjectTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports